import { Confirmation } from "@jewlr/storybook/modal"
import { useCallback, useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"

const OptOutModal = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [show, setShow] = useState(false)

  const handleClose = useCallback(() => {
    setSearchParams(
      (prevParams) => {
        prevParams.delete("optout")
        return prevParams
      },
      { replace: true }
    )
  }, [searchParams])

  useEffect(() => {
    const optout = searchParams.get("optout")
    setShow(optout === "mothersday")
  }, [searchParams])

  return (
    <Confirmation
      cancelText="OK"
      description="We will not send you Mother's Day related emails for now. Stay tuned for our upcoming offers and exciting news."
      onCancel={handleClose}
      primary="cancel"
      show={show}
      variant="squircle"
    />
  )
}

export default OptOutModal
